import React from 'react';
import { Link } from 'react-router-dom';
import Veg from '../images/icon/veg.png';
import Bakery from '../images/icon/bakery.png';
import Precut from '../images/icon/5.png';
import Butchery from '../images/icon/3.png';
import Dairy from '../images/icon/2.png';
import Fruits from '../images/icon/fruits023.png';

const CategoryGrid = () => {
  const categories = [

    { 
      id: 3, 
      name: 'Pre-cut Vegetables',
      url: 'category/pre-cut vegetables',
      image: Precut
    }, 
    { 
      id: 4, 
      name: 'Butchery', 
      url: 'category/butchery',
      image: Butchery
    },
    { 
      id: 5, 
      name: 'Dairy', 
      url: 'category/dairy',
      image: Dairy
    },
    { 
      id: 6, 
      name: 'Bakery', 
      url: 'category/bakery',
      image: Bakery 
    },
        { 
      id: 1, 
      name: 'Vegetables', 
      url: 'category/vegetables',
      image: Veg
    },
    { 
      id: 2, 
      name: 'Fruits', 
      url: 'category/fruits',
      image: Fruits
    },
  ];

  return (
    <div className="container my-4">
      <h1 className="display-6 text-center mb-4">Explore our store</h1>
      <div className="row gx-2 gy-3">
        {categories.map(category => (
          <div key={category.id} className="col-6 col-md-4 col-lg-3">
            <Link
              to={category.url}
              className="d-block rounded overflow-hidden text-decoration-none text-dark h-100"
              style={{
                border: '1px solid #eee',
                transition: 'all 0.3s ease',
                display: 'flex',
                flexDirection: 'column',
                fontSize: '0.95rem',
              }}
              onMouseOver={e => (e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)')}
              onMouseOut={e => (e.currentTarget.style.boxShadow = 'none')}
            >
              {/* Updated image wrapper to make image cover */}
              <div style={{ 
                position: 'relative', 
                width: '100%', 
                paddingTop: '75%', // aspect ratio
                backgroundColor: '#7dbfa2' 
              }}>
                <img
                  src={category.image}
                  alt={category.name}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
              <div className="text-center px-2 py-2 flex-grow-1 d-flex align-items-center justify-content-center">
                <span className="fw-semibold">{category.name}</span>
              </div>
            </Link>
          </div>
        ))}
      </div>
      <div className="text-center mt-4 ">
        {/* <Link to="/products">
          <button className="btns btn btn-lg px-4 py-2  ">
            Start shopping
          </button>
        </Link> */}
      </div>
    </div>
  );
};

export default CategoryGrid;
